module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('div', {
    on: {
      "click": _vm.hide
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "vue-mask",
    on: {
      "click": function($event) {
        _vm.hideOnBlur && (_vm.currentValue = false)
      }
    }
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "vue-dialog"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1095b0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-dialog/index.vue
// module id = 156
// module chunks = 1